import {ChangeDetectionStrategy, Component, computed, inject, ViewChild} from '@angular/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {RouterLink} from '@angular/router';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {map, shareReplay} from 'rxjs/operators';
import {UserMenuComponent} from '../user-menu/user-menu.component';
import {OrgSwitcherComponent} from './org-switcher/org-switcher.component';
import {PatientOmnisearchComponent} from './patient-omnisearch/patient-omnisearch.component';
import {OrganisationStore} from '../../stores/organisation.store';
import {ThemeService} from '../../services/theme.service';

@Component({
  selector: 'app-toolbar',
  imports: [
    MatToolbarModule, MatIconModule, MatButtonModule,
    UserMenuComponent, OrgSwitcherComponent, PatientOmnisearchComponent, RouterLink,
  ],
  templateUrl: './toolbar.component.html',
  styleUrl: './toolbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarComponent {
  readonly orgStore = inject(OrganisationStore);
  readonly themeService = inject(ThemeService);
  private breakpointObserver = inject(BreakpointObserver);

  @ViewChild('omnisearch') omnisearch!: PatientOmnisearchComponent;

  readonly isHandset = toSignal(
    this.breakpointObserver.observe(Breakpoints.Handset)
      .pipe(map(r => r.matches), shareReplay(1)),
    {initialValue: false},
  );
  readonly isTablet = toSignal(
    this.breakpointObserver.observe(Breakpoints.Tablet)
      .pipe(map(r => r.matches), shareReplay(1)),
    {initialValue: false},
  );
  readonly isCompact = computed(() => this.isHandset() || this.isTablet());

  openOmnisearch(): void {
    this.omnisearch?.openSearch();
  }
}
